export default "__VITE_ASSET__3BlZvaSM__"